import { get, post } from '@/api/request';

const URI = "/user"

// 用户管理-用户列表
export const listUser = (page, size, params) => post(`${URI}/list?type=USER&page=${page}&size=${size}`, params);
// 用户管理-保存用户
export const saveOrUpdateUser = params => post(`${URI}/save`, params);
// 用户管理-获取用户信息
export const getUser = id => get(`${URI}/info/${id}`);
// 用户管理-删除用户
export const delUser = id => get(`${URI}/delete/${id}`);
// 用户管理-当前用户
export const currUser = () => get(`${URI}/info`)
// 票据管理-查询业务员
export const listSalesman = name => post(`${URI}/bussinessUser?name=${name}`);


// WEBPACK FOOTER //
// ./src/api/system/user.js